'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _services = require('../actions/services');

var _language = require('../types/language');

var _enum = require('../enum');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  healthGroups: [],
  services: [],
  subServices: [],
  offers: [],
  units: [],
  redeem: {
    patient: {},
    state: undefined
  },
  lastAddedOffer: null,
  selectedOffer: null,
  snackBar: {
    show: false,
    message: ''
  },
  /** Services Module */
  serviceDetailsModal: { serviceDetails: {}, isOpen: false },
  branchDoctorsModal: { branchDoctorsDetails: {}, isOpen: false },
  servicesListPage: undefined,
  servicesListPageLoadState: _enum.status.SHOULD_CALL_API,
  searchedServices: undefined,
  searchedServicesLoadState: _enum.status.SHOULD_CALL_API,
  addServiceLoadState: _enum.status.SHOULD_CALL_API,
  addServiceLoadMessage: undefined,
  editServiceLoadState: _enum.status.SHOULD_CALL_API,
  editServiceLoadMessage: undefined,
  serviceDetailsLoadState: _enum.status.SHOULD_CALL_API,
  serviceDetails: undefined,
  entitySpecialtyServicesLoadState: _enum.status.SHOULD_CALL_API,
  entitySpecialtyServices: undefined,
  deleteServiceLoadState: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _services.SERVICES.HEALTH_GROUPS.LOAD:
      return _extends({}, state, {
        isHealthGroupsLoaded: false,
        isHealthGroupsLoading: true
      });

    case _services.SERVICES.HEALTH_GROUPS.LOAD_DONE:
      {
        var healthGroups = payload.healthGroups;

        return _extends({}, state, {
          healthGroups: healthGroups,
          isHealthGroupsLoaded: true,
          isHealthGroupsLoading: false
        });
      }

    case _services.SERVICES.SERVICES.LOAD:
      return _extends({}, state, {
        isServicesLoaded: false,
        isServicesLoading: true
      });

    case _services.SERVICES.SERVICES.LOAD_DONE:
      {
        var services = payload.services;

        return _extends({}, state, {
          services: services,
          isServicesLoaded: true,
          isServicesLoading: false
        });
      }

    case _services.SERVICES.SUB_SERVICES.LOAD:
      return _extends({}, state, {
        isSubServicesLoaded: false,
        isSubServicesLoading: true
      });

    case _services.SERVICES.SUB_SERVICES.LOAD_DONE:
      {
        var subServices = payload.subServices;

        return _extends({}, state, {
          subServices: subServices,
          isSubServicesLoaded: true,
          isSubServicesLoading: false
        });
      }

    case _services.SERVICES.SUB_SERVICES.RESET:
      {
        return _extends({}, state, {
          subServices: []
        });
      }

    case _services.SERVICES.OFFER.LOAD_ALL:
      return _extends({}, state, {
        isOffersLoaded: false,
        isOffersLoading: true
      });

    case _services.SERVICES.OFFER.LOAD_ALL_DONE:
      {
        var offers = payload.offers;

        return _extends({}, state, {
          offers: offers,
          isOffersLoaded: true,
          isOffersLoading: false,
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Offer added successfully' : 'تم إضافة العرض بنجاح'
          }
        });
      }

    case _services.SERVICES.OFFER.ADD:
      return _extends({}, state, {
        isOfferAdded: false,
        isOfferAdding: true
      });

    case _services.SERVICES.OFFER.ADD_DONE:
      {
        var offer = payload.offer;

        return _extends({}, state, {
          lastAddedOffer: offer,
          isOfferAdded: true,
          isOfferAdding: false,
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Offer added successfully' : 'تم إضافة العرض بنجاح'
          }
        });
      }

    case _services.SERVICES.OFFER.ADD_FAIL:
      {
        var err = payload.err;

        return _extends({}, state, {
          err: err,
          isOfferAdded: false,
          isOfferAdding: false,
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Invalid data' : 'البيانات غير صحيحة'
          }
        });
      }

    case _services.SERVICES.OFFER.EDIT:
      return _extends({}, state, {
        isOfferEdited: false,
        isOfferEditing: true
      });

    case _services.SERVICES.OFFER.EDIT_DONE:
      {
        return _extends({}, state, {
          isOfferEdited: true,
          isOfferEditing: false,
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Offer edited successfully' : 'تم تعديل العرض بنجاح'
          }
        });
      }

    case _services.SERVICES.OFFER.EDIT_FAIL:
      {
        var _err = payload.err;

        return _extends({}, state, {
          err: _err,
          isOfferEdited: false,
          isOfferEditing: false,
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Invalid data' : 'البيانات غير صحيحة'
          }
        });
      }

    case _services.SERVICES.OFFER.SELECT:
      {
        var _offer = payload.offer;

        return _extends({}, state, {
          selectedOffer: _offer
        });
      }

    case _services.SERVICES.OFFER.RESET:
      {
        return _extends({}, state, {
          selectedOffer: null,
          services: [],
          subServices: [],
          units: []
        });
      }

    case _services.SERVICES.CODE.REDEEM:
      return _extends({}, state, {
        redeem: {
          patient: {},
          state: _services.SERVICES.CODE.REDEEM
        },
        isCodeRedeeming: true,
        isCodeRedeemed: false
      });

    case _services.SERVICES.CODE.REDEEM_DONE:
      {
        return _extends({}, state, {
          redeem: {
            patient: payload.redeemed,
            state: _services.SERVICES.CODE.REDEEM_DONE
          },
          isCodeRedeeming: false,
          isCodeRedeemed: true
        });
      }

    case _services.SERVICES.CODE.REDEEM_FAIL:
      {
        return _extends({}, state, {
          redeem: {
            patient: {},
            state: _services.SERVICES.CODE.REDEEM_FAIL
          },
          isCodeRedeeming: false,
          isCodeRedeemed: false
        });
      }

    case _services.SERVICES.CODE.RESET_REDEEM:
      {
        return _extends({}, state, {
          redeem: {
            patient: {},
            state: _services.SERVICES.CODE.RESET_REDEEM
          }
        });
      }

    case _services.SERVICES.UNITS.LOAD:
      return _extends({}, state, {
        isUnitsLoaded: false,
        isUnitsLoading: true
      });

    case _services.SERVICES.UNITS.LOAD_DONE:
      {
        var units = payload.units;

        return _extends({}, state, {
          units: units,
          isUnitsLoaded: true,
          isUnitsLoading: false
        });
      }

    case _services.SERVICES.SNACK_BAR.HIDE:
      return _extends({}, state, {
        snackBar: {
          show: false,
          message: ''
        }
      });
    /** Services Module */
    case _services.SERVICES.MODAL.SERVICE_DETAILS_TOGGLE:
      return _extends({}, state, {
        serviceDetailsModal: { isOpen: payload.isOpened }
      });

    case _services.SERVICES.MODAL.BRANCH_DOCTORS_TOGGLE:
      return _extends({}, state, {
        branchDoctorsModal: { isOpen: payload.isOpened }
      });

    case _services.SERVICES.SET_SERVICE_DETAILS:
      return _extends({}, state, {
        serviceDetailsModal: _extends({}, state.serviceDetailsModal, {
          serviceDetails: payload.serviceDetails
        })
      });

    case _services.SERVICES.SERVICES_LIST.FETCH:
      return _extends({}, state, { servicesListPageLoadState: _enum.status.FETCHING, servicesListPage: undefined });
    case _services.SERVICES.SERVICES_LIST.SUCCESS:
      {
        return _extends({}, state, {
          servicesListPageLoadState: _enum.status.SUCCESS,
          servicesListPage: payload.payload
        });
      }
    case _services.SERVICES.SERVICES_LIST.FAIL:
      return _extends({}, state, {
        servicesListPageLoadState: _enum.status.FAIL,
        servicesListPage: payload.payload
      });

    case _services.SERVICES.GET_SERVICE_DETAILS.FETCH:
      return _extends({}, state, { serviceDetailsLoadState: _enum.status.FETCHING, serviceDetails: undefined });
    case _services.SERVICES.GET_SERVICE_DETAILS.SUCCESS:
      {
        return _extends({}, state, {
          serviceDetailsLoadState: _enum.status.SUCCESS,
          serviceDetails: payload.payload
        });
      }
    case _services.SERVICES.GET_SERVICE_DETAILS.FAIL:
      return _extends({}, state, {
        serviceDetailsLoadState: _enum.status.FAIL,
        serviceDetails: payload.payload
      });

    case _services.SERVICES.DELETE_SERVICE.SUBMIT:
      return _extends({}, state, { deleteServiceLoadState: _enum.status.SUBMITING });
    case _services.SERVICES.DELETE_SERVICE.SUCCESS:
      {
        return _extends({}, state, {
          deleteServiceLoadState: _enum.status.SUCCESS
        });
      }
    case _services.SERVICES.DELETE_SERVICE.FAIL:
      return _extends({}, state, {
        deleteServiceLoadState: _enum.status.FAIL
      });

    case _services.SERVICES.SEARCH.LOAD:
      return _extends({}, state, { searchedServicesLoadState: _enum.status.FETCHING, searchedServices: undefined });

    case _services.SERVICES.SEARCH.SUCCESS:
      {
        return _extends({}, state, {
          searchedServicesLoadState: _enum.status.SUCCESS,
          searchedServices: payload.payload
        });
      }
    case _services.SERVICES.SEARCH.FAIL:
      return _extends({}, state, {
        searchedServicesLoadState: _enum.status.FAIL,
        searchedServices: payload.payload
      });

    case _services.SERVICES.ADD_SERVICE.LOAD:
      return _extends({}, state, { addServiceLoadState: _enum.status.SUBMITING });

    case _services.SERVICES.ADD_SERVICE.SUCCESS:
      return _extends({}, state, {
        addServiceLoadState: _enum.status.SUCCESS,
        addServiceLoadMessage: payload.payload
      });

    case _services.SERVICES.ADD_SERVICE.FAIL:
      return _extends({}, state, { addServiceLoadState: _enum.status.FAIL, addServiceLoadMessage: payload.payload });

    case _services.SERVICES.EDIT_SERVICE_DETAILS.SUBMIT:
      return _extends({}, state, { editServiceLoadState: _enum.status.SUBMITING });

    case _services.SERVICES.EDIT_SERVICE_DETAILS.SUCCESS:
      return _extends({}, state, {
        editServiceLoadState: _enum.status.SUCCESS,
        editServiceLoadMessage: payload.payload
      });

    case _services.SERVICES.EDIT_SERVICE_DETAILS.FAIL:
      return _extends({}, state, {
        editServiceLoadState: _enum.status.FAIL,
        editServiceLoadMessage: payload.payload
      });

    case _services.SERVICES.GET_ENTITY_SPECIALTY_SERVICE.FETCH:
      return _extends({}, state, { entitySpecialtyServicesLoadState: _enum.status.FETCHING });

    case _services.SERVICES.GET_ENTITY_SPECIALTY_SERVICE.SUCCESS:
      return _extends({}, state, {
        entitySpecialtyServicesLoadState: _enum.status.SUCCESS,
        entitySpecialtyServices: payload.payload
      });

    case _services.SERVICES.GET_ENTITY_SPECIALTY_SERVICE.FAIL:
      return _extends({}, state, {
        entitySpecialtyServicesLoadState: _enum.status.FAIL,
        entitySpecialtyServices: payload.payload
      });

    default:
      return state;
  }
};

module.exports = exports['default'];